module.exports = __webpack_public_path__ + "static/vk-7562b747b622f7cdde0224018cf31f40.png";